<template>
	<div>
		<div class="flex justify-between items-end mb-14-c">
			<div>
				<ReportsNav />
			</div>
		</div>

		<div class="row">
			<!-- <div class="col-auto mb-2 text-left">
						<FilterClient class="d-inline-block"
							filterId="transaction"
							:clients_prop="listClients"
						>
						</FilterClient>
					</div> -->

			<!-- <div class="col-auto mb-2 text-left">
						<ExportAsButton class="d-inline-block">
						</ExportAsButton>
					</div> -->
		</div>

		<div class="row">
			<div class="col-12 table-responsive p-0">
				<table class="table table--report text-nowrap">
					<thead style="background-color: #0f0f17">
						<tr class="text-center">
							<th>NAME</th>
							<th>HIN</th>
							<th>BANK</th>
							<th>RPED</th>
							<th>BALANCE</th>
						</tr>
					</thead>
					<tbody v-if="apiStatusGetClients == 'loading'">
						<tr>
							<td class="text-center" colspan="5">
								<Loader size_prop="10em"></Loader>
							</td>
						</tr>
					</tbody>

					<tbody v-else>
						<tr v-for="(client, index) in clients" :key="client.hin">
							<td>{{ client.name }}</td>
							<td>{{ client.hin }}</td>
							<td class="text-center">{{ client.bank }}</td>
							<td class="text-center">{{ client.rped }}</td>

							<td class="text-right">
								<Loader v-if="numberFormatExtend(clientsBalance['bal' + client.rped]) == '-'" size_prop="14px" borderSize_prop="1px">
								</Loader>
								<span v-else>
									Rp. {{ numberFormatExtend(clientsBalance['bal' + client.rped]) }}
								</span>
							</td>

							<!-- <td class="text-right">{{ numberFormatExtend(Decimal.mul(client.availableBalance, -->
							<!-- streamingRateBuy).toFixed(2)) }}</td> -->
						</tr>
					</tbody>
					<tfoot>

					</tfoot>
				</table>
			</div>
		</div>

		<div class="row">
			<div class="col">
				<Pagination2 :totalData_prop="totalClients" @changePage="setClients">
				</Pagination2>
			</div>
		</div>

	</div>
</template>

<script>
import axios, { abortController } from '@/api/axios.js'
import { Decimal } from 'decimal.js'

import ReportsNav from '@/components/reports/ReportsNav.vue'

import Pagination2 from '@/components/Pagination2.vue'
import Loader from '@/components/Loader.vue'

export default {
	name: 'Clients',

	components: {
		ReportsNav,
		Pagination2,
		Loader,
	},

	data() {
		return {
			Decimal: Decimal,

			clients: [],
			totalClients: 1,
			apiStatusGetClients: 'idle',

			cancelTokenApiGetClients: '',

			clientsBalance: {},

		}
	},

	computed: {
		accountLevel() {
			return this.$store.getters.getAccountLevel
		}
	},

	created() {
		if (this.accountLevel == 'ib' || this.accountLevel == 'fm') {
			this.setClients()

			// axios.post('/v2/rrs/list_clients', {
			// 	user_id: this.$store.state.userId
			// })
		}
	},

	methods: {
		setClientsFilter() {
			axios.post('/v2/rrs/list_clients', {
				user_id: this.$store.state.userId
			}).then(response => {
				this.listClients = response.data.data.body

				console.log('Berhasil setClientsFilter', response)
			}).catch(error => {
				if (error.response) {
					/*
					 * The request was made and the server responded with a
					 * status code that falls out of the range of 2xx
					 */
					console.log(error.response.data)
					console.log(error.response.status)
					console.log(error.response.headers)
				} else if (error.request) {
					/*
					 * The request was made but no response was received, `error.request`
					 * is an instance of XMLHttpRequest in the browser and an instance
					 * of http.ClientRequest in Node.js
					 */
					console.log(error.request)
				} else {
					// Something happened in setting up the request and triggered an Error
					console.log(error.message)
				}
				console.log('Gagal setClientsFilter', error.config)
			})
		},

		setClients(skip = 0, limit = 10) {
			this.apiStatusGetClients = 'loading'

			if (this.cancelTokenApiGetClients) {
				//cancel api get transactions
				this.cancelTokenApiGetClients.controller.abort()
			}
			this.cancelTokenApiGetClients = abortController()

			axios.post('/v2/rrs/list_trade_account?offset=' + skip + '&limit=' + limit, {
				user_id: this.$store.state.userId
			}, {
				signal: this.cancelTokenApiGetClients.signal,
			}).then(response => {
				const dataResponse = response.data.data.body
				this.totalClients = response.data.data.count

				// const sortedClients = dataResponse.sort((a, b) => {
				// 	const aHin = a.trade_account.hin
				// 	const bHin = b.trade_account.hin

				// 	if (aHin < bHin) {
				// 		return -1
				// 	}
				// 	if (aHin > bHin) {
				// 		return 1
				// 	}
				// 	return 0
				// })

				if (this.totalClients == 0 && dataResponse.length > 0) {
					this.totalClients = this.listClients.length
				}

				this.clients = []
				this.clientsBalance = {}

				dataResponse.forEach((client, index) => {
					// get balance of each clients
					axios.post('/v2/rrs/account_balance', {
						account_no: client.bank_account[0].account_no
					}).then(response2 => {
						const balance = response2.data.data.body.balance
						this.$set(this.clientsBalance, 'bal' + client.bank_account[0].account_no, balance)
					})

					this.$set(this.clients, index, {
						'hin': client.trade_account.hin,
						'name': client.fullname,
						'bank': client.bank_account[0].name,
						'rped': client.bank_account[0].account_no,
						'balance': 'loading',

						// 'allowTrade': value.attributes.allowClientTrade,
						// 'availableBalance': value.attributes.availableTrade,
						// 'reservedBalance': value.attributes.totalReserveFunds,
					})
				})

				this.apiStatusGetClients = 'success'
				console.log('Berhasil setClients')
			}).catch(error => {
				this.apiStatusGetClients = 'error'
				if (error.response) {
					/*
					 * The request was made and the server responded with a
					 * status code that falls out of the range of 2xx
					 */
					console.log(error.response.data)
					console.log(error.response.status)
					console.log(error.response.headers)
				} else if (error.request) {
					/*
					 * The request was made but no response was received, `error.request`
					 * is an instance of XMLHttpRequest in the browser and an instance
					 * of http.ClientRequest in Node.js
					 */
					console.log(error.request)
				} else {
					// Something happened in setting up the request and triggered an Error
					console.log(error.message)
				}
				console.log('Gagal setClients', error.config)
			})
		},
	},
}
</script>

<style scoped></style>